import { INTEGRATION_SETTING_TYPE } from '../../../../common/constants/IntegrationConstants';
import { getConfigStatusKeyName } from '../../../../common/util/crmIntegrationUtils/crmUtils';
import {
  cancelIntegrationContextStatus,
  fetchIntegrationContextStatus,
  saveIngrationContextStatus,
} from '../../../routines/integrations/supportIntegrationRoutines';

const initialState = {
  linkEntityOfContactAllNaNa: false,
  contactCreateContactNaNa: false,
  loading: false,
  error: null,
};

const integrationContextStatusReducer = (state = initialState, action) => {
  switch (action.type) {
    case fetchIntegrationContextStatus.TRIGGER:
      return {
        ...state,
        loading: true,
        error: false,
      };

    case fetchIntegrationContextStatus.SUCCESS: {
      const data = action.payload || {};
      const newState = Object.values(data)
        .filter(({ settingType }) =>
          [
            INTEGRATION_SETTING_TYPE.CONTACT_CREATE,
            INTEGRATION_SETTING_TYPE.LINK_ENTITY_OF_CONTACT,
          ].includes(settingType)
        )
        .reduce(
          (stateObj, item) => {
            const { settingType, entityLevel, criteria, syncType } = item;
            const key = getConfigStatusKeyName(
              settingType,
              entityLevel,
              criteria,
              syncType
            );
            return {
              ...stateObj,
              [key]: item.enable === 1,
            };
          },
          { ...state }
        );

      return {
        ...state,
        ...newState,
        persistedIntegrationContextStatus: newState,
        loading: false,
        error: null,
      };
    }
    case saveIngrationContextStatus.TRIGGER:
    case saveIngrationContextStatus.SUCCESS: {
      const { entityLevel, settingType, criteria, enable, syncType } =
        action.payload;
      const key = getConfigStatusKeyName(
        settingType,
        entityLevel,
        criteria,
        syncType
      );
      const newState = {
        ...state,
        [key]: enable === 1,
      };
      return {
        ...state,
        ...newState,
        persistedIntegrationContextStatus: newState,
        loading: false,
        error: null,
      };
    }

    case cancelIntegrationContextStatus.TRIGGER: {
      const { toggleKeyName, persistedToggleStatus } = action.payload;
      const newState = {
        ...state,
        [toggleKeyName]: persistedToggleStatus === 1,
      };
      return {
        ...state,
        ...newState,
        loading: false,
        error: null,
      };
    }
    default:
      return state;
  }
};
export default integrationContextStatusReducer;
